<template>
  <div class="group-container">
    <slot>
      <BaseButton
        v-for="(item, index) in options"
        :key="index"
        :disabled="disabled"
        :className="item.active ? 'active' : null"
        @click="onClick($event, item)"
      >
        {{ item.text }}
      </BaseButton>
    </slot>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      default: () => ([]),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    onClick (e, item) {
      this.$emit('change', item)
    },
  },
}
</script>

<style scoped>
.group-container {
  display: flex;
}

.group-container .btn {
  border-radius: 0;
  padding-left: 25px;
  padding-right: 25px;
  outline: none;
  box-shadow: none;
  background-color: #6C757D !important;
  color: #fff !important;
}

.group-container .btn.active {
  background-color: #545B62 !important;
}

.group-container .btn:first-of-type {
  border-radius: .25rem 0 0 .25rem;
}

.group-container .btn:last-of-type {
  border-radius: 0 .25rem .25rem 0;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseButtonGroup.vue